import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '../services';
import { getOfferRecordCurrentIndex, updateOfferRecord } from '@/components/OfferRecord';
import { fontEndConfig } from '@/shared/utils';
const initData = {
    topCarDetails: {},
    monitorData: [
        { name: 'browseNum', monitorName: '浏览量', monitorCount: 0 },
        { name: 'fousBuyerNum', monitorName: '关注量', monitorCount: 0 },
        { name: 'bidBuyerNum', monitorName: '出价会员数', monitorCount: 0 },
        { name: 'bidNum', monitorName: '出价次数', monitorCount: 0 },
        { name: 'premiumPriceY', monitorName: '溢出金额', monitorCount: 0 },
    ],
    highestPriceStage: 0,
    bidNum: 0,
    visible: false,
};
export default createStore({
    state: Object.assign({}, initData),
    effects: {
        getCarDetail(params, { rootState }) {
            const auctionId = rootState.router.query.id;
            Api.auction.getAuctionBaseInfo({
                auctionId,
            }).then((res) => {
                const { carmodelName, license, locationName, vin, rankDesc, rankLevel, firstImage, auctionMode, status, goodsIdStr } = res;
                const topCarDetails = {
                    carmodelName,
                    license,
                    locationName,
                    vin,
                    rankDesc,
                    rankLevel,
                    firstImage,
                    auctionMode,
                    status,
                    goodsIdStr,
                };
                this.SET_STATE({
                    topCarDetails,
                });
            });
        },
        getMonitorData(type, { state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const auctionId = rootState.router.query.id;
                yield Api.auction.auctionRealTimeMonitor({
                    auctionId,
                }).then((res) => {
                    const { bidNum, highestPriceStage } = res;
                    if (type === 'update') { // 初始化不对比
                        if (bidNum !== state.bidNum) { // 出价次数有变化
                            const pageIndex = getOfferRecordCurrentIndex();
                            if (pageIndex === 1) { // 当前为第一页,直接刷新
                                updateOfferRecord({
                                    index: 1,
                                });
                            }
                            else { // 非第一页，弹框提示
                                this.SET_STATE({
                                    visible: true,
                                });
                            }
                        }
                    }
                    this.SET_MONITOR_DATA(res);
                    this.SET_STATE({
                        bidNum,
                        highestPriceStage,
                    });
                });
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload).forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        SET_MONITOR_DATA(state, payload) {
            state.monitorData.forEach((item) => {
                const key = item.name;
                if (key === 'premiumPriceY') {
                    item.monitorCount = payload[key] || fontEndConfig.noValueReplace;
                }
                else {
                    item.monitorCount = payload[key] || 0;
                }
            });
        },
    },
});
